/**
 * Thin HTTP wrapper around the server-backed user preference API (v2): the logged-in user's own
 * MedChron export profile, read and written. No state, no mapping — see
 * `userPreferencesService.mapper.ts` for API⇄UI conversion.
 */
import type { APIInstance } from "@/services/apiService";
import {
  USER_PREFERENCE_KEY_MEDCHRON_EXPORT,
  type UserPreferencePutRequest,
  type UserPreferenceResponse,
} from "@/services/userPreferencesService.types";

export class UserPreferencesService {
  private api: APIInstance;

  constructor(api: APIInstance) {
    this.api = api;
  }

  /** Logged-in user's own saved MedChron export preferences. */
  async getMyMedChronExportPreferences(): Promise<UserPreferenceResponse> {
    const response = await this.api.get<UserPreferenceResponse>(
      `/me/preference/${USER_PREFERENCE_KEY_MEDCHRON_EXPORT}`
    );
    return response.data;
  }

  /** Replaces the logged-in user's own MedChron export preferences (full replace, no PATCH). */
  async putMyMedChronExportPreferences(
    body: UserPreferencePutRequest
  ): Promise<UserPreferenceResponse> {
    const response = await this.api.put<UserPreferenceResponse>(
      `/me/preference/${USER_PREFERENCE_KEY_MEDCHRON_EXPORT}`,
      body
    );
    return response.data;
  }
}
